module.exports = __webpack_public_path__ + "static/media/userManual.98b2ae64.svg";